/**
 * @module enum
 */
export enum HistoryMsgGetTypeEnum {
    /**
     * 获取云端更老的消息
     */
    V2TIM_GET_CLOUD_OLDER_MSG = 1,
    /**
     * 获取云端更新的消息
     */
    V2TIM_GET_CLOUD_NEWER_MSG,
    /**
     * 获取本地更老的消息
     */
    V2TIM_GET_LOCAL_OLDER_MSG,
    /**
     * 获取本地更新的消息
     */
    V2TIM_GET_LOCAL_NEWER_MSG,
}
